import { render, staticRenderFns } from "./CourseV2List.vue?vue&type=template&id=66b53710&"
import script from "./CourseV2List.vue?vue&type=script&lang=ts&"
export * from "./CourseV2List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports